export const maskString = (name: string) => {
    return name
        .split(' ')
        .map((word) => {
            if (word.length <= 2) {
                return word;
            }
            return word[0] + '*'.repeat(word.length - 2) + word[word.length - 1];
        })
        .join(' ');
};
